export const isMobileDevice = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

export const isNativeApp = () => window.riseupPlatform === 'flutter_web';

export const isIosNativeApp = () => isNativeApp() && window.devicePlatform === 'ios';
